<template>
  <div>
    <p>
      Här får du med liggande genomskjutningsskydd till varje nivå. Genomskjutningsskydden hindrar genomskjutning av pallen och är som regel ett krav för att pallstället ska vara godkänt.
    </p>
  </div>
</template>
<script>

import RackGuardsInfo from "@/components/infotext/RackGuardsInfo.vue";

export default {
  components: {
    RackGuardsInfo
  }
}

</script>